import SubScript from "src/component/common/Subscript/SubScript"
import {LoginWrap} from "src/styles/views/Login"
import {useResetRecoilState} from "recoil"
import {CertNumState, TelNumState, TimeOutState, TranIdState} from "src/store/recoil/common"
import {useEffect} from "react"
import useSubscriptQuery from "src/hooks/useSubscriptQuery"
import Loading from "src/component/common/Loading"
import { NavLink } from 'react-router-dom'
// import { NavLink } from 'react-router-dom'

const Login = () => {
    const subscript = useSubscriptQuery()
    const ResetTelNum = useResetRecoilState(TelNumState)
    const ResetTimeOut = useResetRecoilState(TimeOutState)
    const ResetTranId = useResetRecoilState(TranIdState)
    const ResetCertNum = useResetRecoilState(CertNumState)
    useEffect(() => {
        return () => {
            ResetTelNum()
            ResetTimeOut()
            ResetTranId()
            ResetCertNum()
        }
    }, [ResetCertNum, ResetTelNum, ResetTimeOut, ResetTranId])

    return (
        <LoginWrap>
            {subscript.LoginIsLoading && <Loading/>}
            <SubScript/>
            <p>
                휴대폰가족보호 회원이 아니신가요?
                <NavLink to={"/join"}>회원가입</NavLink>
            </p>
        </LoginWrap>
    )
}
export default Login